import React, { Component } from "react";
import _ from "lodash";

import QuantityAdjustmentArrow from "./components/quantityAdjustmentArrow/quantityAdjustmentArrow";

import "./lineItem.css";

class LineItem extends Component {
  render() {
    const lineItem = this.props.lineItem;
    // find color value
    const color = _.find(
      lineItem.variant.selectedOptions,
      option => option.name === "Color"
    ).value;
    // find size value
    const size = _.find(
      lineItem.variant.selectedOptions,
      option => option.name === "Size"
    ).value;

    return (
      <div className="lineItem" key={lineItem.id}>
        <div className="imageContainer">
          <img src={lineItem.variant.image.src} alt="Line Item" />
        </div>
        <div className="informationContainer">
          <p className="title">{lineItem.title}</p>
          <div className="variant">
            <p>Size: {size}</p>
            <p>Color: {color}</p>
          </div>
          <div className="quantity">
            <p>Quantity: {lineItem.quantity}</p>
            <QuantityAdjustmentArrow adjustment={1} lineItem={lineItem} />
            <QuantityAdjustmentArrow adjustment={-1} lineItem={lineItem} />
          </div>
        </div>
      </div>
    );
  }
}
export default LineItem;
